import Cookies from 'js-cookie';
import moment from 'moment';
import { ICmsData } from 'model/common';

/** 是否为移动设备 */
export const isMobile = function() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Mini/i.test(window.navigator.userAgent);
};

/** CMS 配置项是否生效，默认需要配置时间范围 */
export const validCms = function(content) {
    if (!content || !content.length || !(content instanceof Array)) return;
    const now = moment();
    return content.find(
        item => item && item.date && item.date.length === 2 && now.isBetween(item.date[0], item.date[1]),
    );
};

/**
 * UTC时间格式化为本地时区时间
 * @param time
 * @returns
 */
export const formatLocalTime = function(time) {
    return moment
        .utc(time)
        .local()
        .format('YYYY-MM-DD');
};

export function getUserName() {
    return decodeURIComponent(Cookies.get('__venus_login_name__') || '');
}

export function mergeDataByCode(data?: ICmsData[] | null): { readonly [index: string]: any } {
    const result = {};
    if (!data) {
        return result;
    }
    data.forEach(item => {
        if (item.code) {
            result[item.code] = item.content;
        }
    });
    return result;
}

function getLang() {
    const { searchParams, host } = new URL(window.location.href);
    return (!host.startsWith('local') && host.match(/(\w*).*/)?.[1]) || searchParams.get('lang') || 'en';
}

export const lang = getLang();

export function getCommonHost() {
    const url = new URL(window.location.href);
    const matchStr = url.host.match(/.*(.qxwz.*.com)/);
    return matchStr?.[1] || '.qxwz.com';
}
export const commonHost = getCommonHost();

// 判断浏览器是否支持webp格式
const checkWebpSupported = () => {
    const elem = document.createElement('canvas');
    if (elem.getContext && elem.getContext('2d')) {
        return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }
    return false;
};

const isSupportWebp = checkWebpSupported();

/**
 * OSS 路径转 CDN, 且支持图片转化为webp格式
 * @param str
 */
export function replaceCdn(
    str: string,
    resize = false,
    resizeParam: { width?: number; height?: number } = { width: 250, height: 0 },
) {
    if (str) {
        let url = str
            .replace('http://', 'https://')
            .replace('//venus-pub.oss-cn-beijing.aliyuncs.com/', '//static0.qxwz.com/')
            .replace('//pro-wzw-cdn.oss-cn-beijing.aliyuncs.com/', '//cdn.wzw.cn/');
        // 如果浏览器不支持webp格式，仅做oss转cdn;
        if (!isSupportWebp) return url;
        if (/\.(jpe?g|png)$/.test(url) && resize) {
            if (resizeParam.height) {
                url += `?x-oss-process=image/resize,h_${resizeParam.height * 2}/format,webp`;
            } else {
                url += `?x-oss-process=image/resize,w_${(resizeParam.width as number) * 2}/format,webp`;
            }
        } else if (/\.(jpe?g|png)$/.test(url)) {
            url += `?x-oss-process=image/format,webp`;
        }
        return url;
    }
    return str;
}
